import { cn } from "~/lib/utils";

type ForgeMarkSpinnerVariant = "loading" | "idle";

type ForgeMarkSpinnerProps = {
  readonly className?: string;
  readonly markClassName?: string;
  readonly ringClassName?: string;
  readonly variant?: ForgeMarkSpinnerVariant;
};

/** Branded startup glyph: animated ring while loading, static ring when idle. */
export function ForgeMarkSpinner({
  className,
  markClassName,
  ringClassName,
  variant = "loading",
}: ForgeMarkSpinnerProps) {
  const isLoading = variant === "loading";

  return (
    <div
      aria-label={isLoading ? "Loading" : "Unable to load"}
      className={cn("relative size-12", className)}
      role="status"
    >
      <div
        aria-hidden="true"
        className={cn(
          "absolute inset-0 rounded-full border-[1.5px]",
          isLoading ? "animate-spin border-muted/25 border-t-primary" : "border-muted/45",
          ringClassName,
        )}
        style={isLoading ? { animationDuration: "900ms" } : undefined}
      />
      <img
        alt=""
        aria-hidden="true"
        className={cn(
          "absolute inset-0 m-auto size-5",
          !isLoading && "opacity-55 saturate-[0.85]",
          markClassName,
        )}
        height={20}
        src="/forge-mark.svg"
        width={20}
      />
    </div>
  );
}
